var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBuildingReportBtn)?_c('q-btn',{attrs:{"size":"sm","outline":""},on:{"click":_vm.navigateToStartingPage}},[_vm._v(" Start another report ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }